/**
 * HTTP layer for site-group curfews. The quiet-hours window enforced across a
 * site group.
 *
 * Contains:
 * - fetchSiteGroupCurfew / fetchSiteGroupCurfews / fetchSiteGroupCurfewForSiteGroup: reads
 * - pathSiteGroupCurfew: curfew write
 */
import apiClient from '@sophocles/http-common';
import { generateQueryParams } from '@sophocles/utils';

export const fetchSiteGroupCurfew = (siteGroupCurfewId, queryParams) =>
  apiClient.get(`/sitegroupcurfews/${siteGroupCurfewId}/`).then(res => res.data);

export const fetchSiteGroupCurfews = queryParams =>
  apiClient
    .get('/sitegroupcurfews/', {
      params: generateQueryParams(queryParams),
    })
    .then(res => res.data);

export const fetchSiteGroupCurfewForSiteGroup = siteGroupId =>
  apiClient
    .get('/sitegroupcurfews/', {
      params: generateQueryParams({ site_group: siteGroupId }),
    })
    .then(res => {
      if (res.data?.results.length > 1) {
        throw new Error('More than one site group curfew returned');
      } else if (res.data?.results.length === 0) {
        return null;
      }
      return res.data?.results[0];
    });

export const pathSiteGroupCurfew = (siteGroupCurfewId, values) =>
  apiClient.patch(`/sitegroupcurfews/${siteGroupCurfewId}/`, values).then(res => res.data);
